angular.module("pe4h").directive("licenseIcon", function() {
  return {
    restrict: "E",
    template:
      "<div class='license'>" +
      " <i class='fa fa-fw fa-{{icon}}'></i>" +
      " <span>{{licenseLabel}}: </span>" +
      " <div ng-if='licenseStates.length>0' style='padding-top: 3px'>" +
      "      <strong style='color: #1c75bc;' ng-repeat='state in licenseStates'>" +
      "          <span ng-if='$index>0' style='color:black; font-weight: lighter;'>,</span>{{state}}" +
      "     </strong>" +
      " </div>" +
      " <div ng-if='licenseStates.length==0' style='padding-top: 3px'>" +
      "    <strong>{{license.State}}</strong>" +
      " </div>" +
      "</div>",
    replace: true,
    link: function(scope, elem, attrs) {
      scope.licenseStates = [];
      scope.license = JSON.parse(attrs.license);
      scope.licenses = JSON.parse(attrs.licenses);

      var licenseId = Array.isArray(scope.license)
        ? scope.license[0].LicenseId
        : scope.license.id;

      for (var i in scope.license) {
        scope.licenseStates.push(
          scope.license[i].State || scope.license[i].LicenseState
        );
      }

      var selectedLicense = null;
      for (var i = 0; i < scope.licenses.length; i++) {
        if (scope.licenses[i].Id == licenseId) {
          selectedLicense = scope.licenses[i];
          break;
        }
      }
      scope.licenseLabel = selectedLicense ? selectedLicense.Label : "";

      scope.icon = "";
      switch (selectedLicense.Id) {
        case 2:
          scope.icon = "institution";
          break;
        case 3:
          scope.icon = "flask";
          break;
        case 4:
          scope.icon = "bullhorn";
          break;
        case 5:
          scope.icon = "exclamation-triangle";
          break;
        case 6:
          scope.icon = "dashboard";
          break;
        case 7:
          scope.icon = "flash";
          break;
        case 8:
          scope.icon = "globe";
          break;
        case 9:
          scope.icon = "fire-extinguisher";
          break;
        case 10:
          scope.icon = "globe";
          break;
        case 11:
          scope.icon = "tint";
          break;
        case 12:
          scope.icon = "industry";
          break;
        case 13:
          scope.icon = "map-o";
          break;
        case 14:
          scope.icon = "cog";
          break;
        case 15:
          scope.icon = "wrench";
          break;
        case 16:
          scope.icon = "cogs";
          break;
        case 17:
          scope.icon = "battery-half";
          break;
        case 18:
          scope.icon = "database";
          break;
        case 19:
          scope.icon = "camera";
          break;
        case 20:
          scope.icon = "certificate";
          break;
        case 21:
          scope.icon = "cubes";
          break;
        case 22:
          scope.icon = "life-ring";
          break;
        case 23:
          scope.icon = "road";
          break;
        case 24:
          scope.icon = "leaf";
          break;
        default:
          scope.icon = "wrench";
      }
    }
  };
});
